<template>
  <div class="json-kv-panel">
    <div v-if="!entries.length" class="json-kv-panel-empty">{{ emptyText }}</div>
    <el-row v-else :gutter="20" class="json-kv-panel-row">
      <el-col v-for="(col, colIdx) in splitColumns" :key="colIdx" :span="12">
        <el-form label-position="top" size="small" class="json-kv-panel-form">
          <el-form-item
            v-for="item in col"
            :key="item.key"
            :label="item.label"
            class="json-kv-panel-item"
          >
            <el-input
              v-if="!item.multiline"
              :value="item.display"
              readonly
              class="json-kv-panel-input"
            />
            <el-input
              v-else
              type="textarea"
              :value="item.display"
              readonly
              :autosize="{ minRows: 2, maxRows: 8 }"
              class="json-kv-panel-textarea"
            />
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import {
  buildKeyValueEntries,
  extractSingleRowObject,
  fieldLabel,
  formatPrimitive,
  isNestedCellValue,
  parseJsonValue,
} from '@/utils/jsonNestedTable';

export default {
  name: 'JsonKeyValuePanel',
  props: {
    data: { default: null },
    fieldLabels: { type: Object, default: () => ({}) },
    fieldPriority: { type: Array, default: () => [] },
    emptyText: { type: String, default: '暂无数据' },
    columns: { type: Number, default: 2 },
  },
  computed: {
    rowObject() {
      return extractSingleRowObject(this.data);
    },
    entries() {
      if (!this.rowObject) return [];
      return buildKeyValueEntries(this.rowObject, this.fieldPriority).map(({ key, val }) => ({
        key,
        label: fieldLabel(key, this.fieldLabels),
        display: this.formatFieldValue(val),
        multiline: this.isMultilineValue(val),
      }));
    },
    splitColumns() {
      const n = Math.max(1, this.columns);
      const cols = Array.from({ length: n }, () => []);
      this.entries.forEach((item, idx) => {
        cols[idx % n].push(item);
      });
      return cols;
    },
  },
  methods: {
    isMultilineValue(val) {
      if (isNestedCellValue(val)) return true;
      const s = formatPrimitive(val);
      return s.length > 80 || /\n/.test(s);
    },
    formatFieldValue(val) {
      if (val === null || val === undefined || val === '') return '-';
      if (isNestedCellValue(val)) {
        try {
          return JSON.stringify(parseJsonValue(val), null, 2);
        } catch (e) {
          return String(val);
        }
      }
      return formatPrimitive(val);
    },
  },
};
</script>

<style lang="less" scoped>
.json-kv-panel {
  width: 100%;
  max-height: 70vh;
  overflow: auto;
  padding: 4px 8px 8px;
}

.json-kv-panel-empty {
  color: #909399;
  text-align: center;
  padding: 24px 0;
  font-size: 13px;
}

.json-kv-panel-form {
  width: 100%;
}

.json-kv-panel-item {
  margin-bottom: 12px;
}

.json-kv-panel-item ::v-deep .el-form-item__label {
  line-height: 1.4;
  padding-bottom: 4px;
  font-weight: 500;
  color: #606266;
}

.json-kv-panel-input ::v-deep .el-input__inner,
.json-kv-panel-textarea ::v-deep .el-textarea__inner {
  cursor: default;
  background-color: #fafafa;
  color: #303133;
}

.json-kv-panel-textarea ::v-deep .el-textarea__inner {
  font-family: Consolas, Monaco, 'Courier New', monospace;
  font-size: 12px;
  line-height: 1.5;
}
</style>
